import { searchModuleType } from '../_conf';
import { setRecentlySearch } from '../../md-search-bar/_util';
import * as TYPES from '../../md-search-result/_store/types';
import util from '@/common/util';
import axios from 'axios';
import Data from '@/common/data';
export const SET_SEARCH_MODULE_TYPE = 'SET_SEARCH_MODULE_TYPE';
export const MAP_CHANGE_MUTATION = 'MAP_CHANGE_MUTATION';
export const ADD_KEYWORD_MUTATION = 'ADD_KEYWORD_MUTATION';
export const SET_CMS_STATUS = 'SET_CMS_STATUS';
export const REMOVE_KEYWORD_MUTATION = 'REMOVE_KEYWORD_MUTATION';
export const LAYOUT_UPDATE_MUTATION = 'LAYOUT_UPDATE_MUTATION';
export const LISTING_SOURCE_MUTATION = 'LISTING_SOURCE_MUTATION';
export const UPDATE_URL = 'UPDATE_URL';
export const OTHER_URL_QUERY_MUTATION = 'OTHER_URL_QUERY_MUTATION';
export const NAVIGATOR_DETAIL = 'NAVIGATOR_DETAIL';
export const SET_GO_DETAIL = 'SET_GO_DETAIL';
export const SET_LISTING_SOURCE_READY = 'SET_LISTING_SOURCE_READY';
export const SEARCH_DATA_ACTION = 'SEARCH_DATA_ACTION';
export const RESULT_UPDATE_MUTATION = 'RESULT_UPDATE_MUTATION';
export const QUICK_SEARCH_STATE_MUTATION = 'QUICK_SEARCH_STATE_MUTATION';
export const SET_SEARCH_DATA_READY = 'SET_SEARCH_DATA_READY';
export const SET_BLOCK_ID = 'SET_BLOCK_ID';
export const SET_LISTING_IDS = 'SET_LISTING_IDS';
const IGNORE_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_campaign',
    'utm_id',
    'x_ads_id',
    'x_ads_source',
    'quickSearchCount',
    'quickSearchKey'
];
const queryKeyOnResult = [
    /* search result 中需要用到的参数  start */
    'listingSortOptions',
    'mode',
    'gridOrListType',
    'mapType',
    'layoutType',
    'sort',
    'listingSort',
    'featureListingName',
    'listingSource',
    /* search result 中需要用到的参数  end */
    'nopreset', // 已废弃的参数，若遇到存量url中存在就删除
    'breakCrumbs', // 获取面包屑配置
    '_t'
];
function initState() {
    return {
        goDetail: false,
        forCMS: false,
        searchModuleType: '',
        keywords: [],
        layout: null,
        mapType: null,
        listingSource: '',
        otherUrlQuery: {},
        listingSourceReady: false,
        fetchedSearchData: false,
        mapCondition: {
            rect: null,
            mapPath: null,
            mapSearch: false,
            zoom: 14,
            threshold: 10
        },
        result: {
            counts: 0,
            searchType: 'All',
            listings: [],
            totalPage: 0
        },
        blockId: ''
    };
}

const updateQuickSearchCount = (key, count) => {
    axios
        .get(
            '/api-site/place-data?fetcher=data&source=quicksearchCount&t=' +
                Date.now()
        )
        .then(res => {
            let quickSearchCount = res.data || {};
            if (typeof quickSearchCount === 'string') {
                quickSearchCount = JSON.parse(quickSearchCount);
            }
            quickSearchCount[key] = count;
            axios.post('/api-site/place-data', {
                source: 'quicksearchCount',
                data: JSON.stringify(quickSearchCount)
            });
        });
};

const getters = {
    mode: state => {
        if (!state.layout) {
            return '';
        } else {
            return (
                state.layout +
                (state.layout === 'map' && state.mapType
                    ? '+' + state.mapType
                    : '')
            );
        }
    },
    insightMode(state, getters) {
        if (/insight/.test(getters.mode)) {
            return getters.mode;
        }
        return '';
    },
    isBigMap(state) {
        if (state.searchModuleType === searchModuleType.bigMap) {
            return true;
        }
        return false;
    },
    isGridOrList(state) {
        if (state.searchModuleType === searchModuleType.gridList) {
            return true;
        }
        return false;
    },
    isSold(state, getters, rootState, rootGetters) {
        let reg = /^\d\+/;
        const listingSource = state.listingSource || '';
        return (
            reg.test(listingSource) &&
            listingSource[0] === rootGetters.soldListingFlag
        );
    },
    listingType: (state, getters) => {
        let listingType = '';
        if (
            getters.isSold ||
            (state.listingSource || '').toLowerCase() === 'sold listings'
        ) {
            listingType = 'sold-listing';
        } else if (
            !state.listingSource ||
            state.listingSource.toLowerCase() === 'all listings'
        ) {
            listingType = undefined;
        } else if (
            state.listingSource.toLowerCase() === 'single property promotion'
        ) {
            listingType = 'single-property-promotion';
        } else {
            listingType = 'featured-listing';
        }
        return listingType;
    },
    otherSearchParams: state => {
        let params = Object.assign({}, state.otherUrlQuery);
        if (params.listingSource) {
            delete params.listingSource;
        }
        if (params.key) {
            delete params.key;
        }
        if (params.keywordType) {
            delete params.keywordType;
        }
        for (let kee in state.mapCondition) {
            if (params[kee]) {
                delete params[kee];
            }
        }
        IGNORE_PARAMS.forEach(kee => {
            if (params[kee]) {
                delete params[kee];
            }
        });
        return params;
    },
    locationQuantity(state) {
        if (state.keywords.length > 0) {
            return {
                count: state.keywords.length,
                type: 'addr'
            };
        } else if (state.mapCondition.mapSearch) {
            return {
                count: 1,
                type: 'mapArea'
            };
        } else if (state.mapCondition.mapPath) {
            return {
                count: 1,
                type: 'mapPath'
            };
        } else {
            return {
                count: 0
            };
        }
    },
    locationType(state, getters) {
        const locationQuantity = getters.locationQuantity;
        const keywords = state.keywords;
        const hasNoneType = keywords.find(item => item.keywordType === 'none');
        if (
            locationQuantity.type === 'addr' &&
            locationQuantity.count === 1 &&
            !hasNoneType
        ) {
            return 'single';
        } else if (locationQuantity.count === 0) {
            return 'none';
        } else {
            return 'multi';
        }
    }
};
const mutations = {
    [SET_BLOCK_ID](state, payload) {
        state.blockId = payload;
    },
    [SET_GO_DETAIL](state, payload) {
        state.goDetail = payload;
    },
    [OTHER_URL_QUERY_MUTATION](state, payload = {}) {
        queryKeyOnResult.forEach(key => {
            delete payload[key];
        });
        state.otherUrlQuery = Object.assign({}, payload);
    },
    [SET_SEARCH_MODULE_TYPE](state, payload) {
        state.searchModuleType = payload;
    },
    [MAP_CHANGE_MUTATION](state, payload) {
        let mapCondition = Object.assign({}, state.mapCondition, payload);
        //mapSearch 和 mapPath 不能共存
        if (payload.mapSearch) {
            mapCondition.mapPath = null;
        }
        if (payload.mapPath) {
            mapCondition.mapSearch = false;
        }
        //keywords 与 mapPath/mapSearch 互斥
        if (
            (payload.mapSearch || payload.mapPath) &&
            state.keywords.length > 0
        ) {
            state.keywords = [];
        }
        state.mapCondition = mapCondition;
    },
    [ADD_KEYWORD_MUTATION](state, payload) {
        let keywords = state.keywords;
        if (!payload.keyword) {
            return;
        }
        // keywordType === 'none'表示非suggestion
        // 只能有一个 非 suggestion的搜索项
        if (payload.keywordType === 'none') {
            for (let i = 0; i < keywords.length; i++) {
                if (keywords[i].keywordType === 'none') {
                    keywords.splice(i, 1);
                    break;
                }
            }
        } else {
            if (
                keywords.some(
                    keyword =>
                        keyword.keywordType === payload.keywordType &&
                        keyword.keyword === payload.keyword
                )
            ) {
                return;
            }
        }
        let recentlySearch = state.recentlySearch;
        let index = -1;
        // 找到recentlySearch中第一个与payload相同的索引,并删除
        recentlySearch.some((search, idx) => {
            if (
                search.keywordType === payload.keywordType &&
                search.keyword === payload.keyword
            ) {
                index = idx;
                return true;
            }
            return false;
        });
        if (index !== -1) {
            recentlySearch.splice(index, 1);
        }
        // 最多3个recentlySearch
        if (recentlySearch.length >= 3) {
            recentlySearch = recentlySearch.slice(0, 2);
        }
        // 添加
        recentlySearch.unshift(payload);
        // 将recently search设置cookie
        setRecentlySearch(recentlySearch);
        state.recentlySearch = recentlySearch;

        keywords.push(payload);
        state.keywords = keywords;
        //keywords 与 mapPath/mapSearch 互斥
        state.mapCondition = Object.assign({}, state.mapCondition, {
            mapPath: null,
            mapSearch: false
        });
    },
    [LAYOUT_UPDATE_MUTATION](state, payload) {
        if (this.state.common.isSearchMobileSize) {
            if (payload.layout === 'map') {
                state.layout = 'map';
            } else if (payload.layout === 'insight') {
                state.layout = 'insight';
            } else {
                state.layout = 'grid';
            }
            state.mapType = null;
        } else {
            state.layout = payload.layout;
            state.mapType = payload.mapType;
        }
    },
    [REMOVE_KEYWORD_MUTATION](state, payload) {
        let keywords = state.keywords;
        if (!payload) {
            state.keywords = [];
            return;
        }
        for (let i = 0; i < keywords.length; i++) {
            if (
                keywords[i].keywordType === payload.keywordType &&
                keywords[i].keyword === payload.keyword
            ) {
                keywords.splice(i, 1);
                break;
            }
        }
        state.keywords = keywords;
    },
    [SET_CMS_STATUS](state, payload) {
        state.forCMS = payload;
    },
    [LISTING_SOURCE_MUTATION](state, payload) {
        state.listingSource = payload;
    },
    [SET_LISTING_SOURCE_READY](state, payload) {
        state.listingSourceReady = payload;
    },
    [SET_SEARCH_DATA_READY](state, payload) {
        state.fetchedSearchData = payload;
    },
    [RESULT_UPDATE_MUTATION](state, payload) {
        state.result = Object.assign({}, state.result, payload);
    },
    [QUICK_SEARCH_STATE_MUTATION](state, payload) {
        state.quickSearchState = payload;
    }
};
const actions = () => {
    const RequestListing = util.throttledRequest();
    const RequestMap = util.throttledRequest();
    return {
        async [SEARCH_DATA_ACTION](
            { commit, state, getters, dispatch, rootGetters, rootState },
            payload = {}
        ) {
            let listingSource = (state.listingSource || '')
                .replace(/^\d\+/, '')
                .replace(/\+/g, ' ');
            let params = Object.assign(
                {
                    ...getters.otherSearchParams
                },
                {
                    featureListingName:
                        [
                            'all listings',
                            'sold listings',
                            'single property promotion'
                        ].indexOf(listingSource.toLowerCase()) !== -1 ||
                        !listingSource
                            ? undefined
                            : listingSource,
                    listingSort: state.sort,
                    layoutType: state.layout,
                    mapType: state.mapType,
                    listingType: getters.resultListingType,
                    page: state.page,
                    pageSize: state.pageSize,
                    isSearching: true,
                    siteId: rootGetters.siteId,
                    ...getters.searchParamsWithMap,
                    ...state.mapCondition
                }
            );

            // 不用ids用listingIds
            delete params['ids'];

            // 请求参数加上listingIds,crmAlertId存在的时候会清空listingIds
            // state.listingIds 默认会存listingIds或者ids的值
            // crmAlertId 存在的时候删掉ids和listingIds
            if (state?.listingIds && !('crmAlertId' in params)) {
                Object.assign(params, { listingIds: state.listingIds });
            }

            // 搜索条件不能有多余的参数
            delete params[rootGetters.siteId];
            if (
                window.sitePageAutoInit === false ||
                window.location.pathname === '/listing-for-cms'
            ) {
                params.timeStamp = Date.now();
            }
            delete params.timeline;
            let ps = [];
            const quickSearchCount =
                Data.URI_REQUEST_PARAMS &&
                Data.URI_REQUEST_PARAMS['quickSearchCount'];
            const quickSearchKey =
                Data.URI_REQUEST_PARAMS &&
                Data.URI_REQUEST_PARAMS['quickSearchKey'];
            if (payload.mapOnly) {
                let mapParams = Object.assign({}, params, {
                    mapSearch: true
                });
                if (state.isBigMap) {
                    mapParams.layoutType = 'map';
                    mapParams.mapType = null;
                }
                commit(TYPES.UPDATE_IS_MAP_LOADING, true);
                mapParams._t = state.blockId;
                // keywordType为“none”时 不在当前地图范围内搜索
                if (
                    'keywordType' in mapParams &&
                    mapParams.keywordType === 'none'
                ) {
                    delete mapParams.rect;
                }
                mapParams.timezone = util.getTimeZone();
                ps.push(
                    RequestMap({
                        url: '/api-site/search/realTimeListings',
                        method: 'get',
                        params: mapParams
                    })
                        .then(data => {
                            // fix:移动端地图模式 save search房源数量不更新的问题
                            if (
                                this.state.common.isMobileSize &&
                                !state.mapType
                            ) {
                                commit(RESULT_UPDATE_MUTATION, data);
                            }
                            commit(TYPES.UPDATE_IS_MAP_LOADING, false);
                            commit(TYPES.MAP_RESULT_UPDATE_MUTATION, {
                                ...data,
                                noMapSearch: getters.noMapSearch
                            });
                            setTimeout(() => {
                                commit(TYPES.SET_MAP_INITED, true);
                            }, 2500);
                            if (
                                state.layout === 'map' &&
                                !state.mapType &&
                                quickSearchCount &&
                                data.counts != quickSearchCount
                            ) {
                                updateQuickSearchCount(
                                    quickSearchKey,
                                    data.counts
                                );
                            }
                        })
                        .catch(error => {
                            commit(TYPES.UPDATE_IS_MAP_LOADING, false);
                            throw error;
                        })
                );
            }

            if (payload.listOnly) {
                if (!params.mapSearch) {
                    delete params.rect;
                } else if (params.rect) {
                    const posArr = params.rect.split(',');
                    let mapPathArr = [
                        { lat: posArr[0], lng: posArr[1] },
                        { lat: posArr[0], lng: posArr[3] },
                        { lat: posArr[2], lng: posArr[3] },
                        { lat: posArr[2], lng: posArr[1] }
                    ];

                    if (rootState.common.isSearchCenter) {
                        mapPathArr = mapPathArr.map(o => JSON.stringify(o));
                        params.condition = params.condition
                            ? JSON.parse(params.condition)
                            : {};
                        params.condition.location ||
                            (params.condition.location = {});
                        params.condition.location.mapPath = mapPathArr;
                        params.condition = JSON.stringify(params.condition);
                    } else {
                        const mapPath = JSON.stringify(mapPathArr);
                        params.mapPath = mapPath;
                    }

                    delete params.rect;
                }
                if (state.isGridOrList) {
                    params.layoutType = state.gridOrListType;
                    params.mapType = null;
                }
                params.mapSearch = false;
                if (!payload.noTimeline) {
                    params.timeline = true;
                }
                if (getters.locationType === 'single') {
                    params.mode = `${params.layoutType}+${params.mapType}`;
                    delete params.layoutType;
                    delete params.mapType;
                }
                params.listingSortOptions = JSON.stringify(
                    state.listingSortOptions
                );
                // params.nopreset = 1;
                state.loading = true;
                params._t = state.blockId;
                params.timezone = util.getTimeZone();
                ps.push(
                    RequestListing({
                        url: '/api-site/search/realTimeListings',
                        method: 'get',
                        params: params
                    }).then(data => {
                        if (!data.counts) {
                            data.counts = 0;
                            data.totalPage = 0;
                        }

                        const len = Object.keys(
                            getters.searchParamsWithMap
                        ).filter(
                            key =>
                                !['condition', 'uiConfig', 'zoom'].includes(key)
                        ).length;

                        const conditions = !!Object.keys(
                            JSON.parse(params?.condition ?? '{}')
                        ).length;
                        const searchBarParamsLen =
                            'listingSource' in getters?.searchParamsWithMap
                                ? len > 1
                                : !!len;
                        setDynamicRegisterParams(
                            Object.assign({}, params, {
                                counts: data?.counts || 0,
                                // 有选择searchbar的参数 中台把参数都放在condition 非中台都放在一级参数（searchParamsWithMap）
                                hasCondition: conditions || searchBarParamsLen
                            })
                        );

                        if (
                            state.goDetail &&
                            Array.isArray(data.listings) &&
                            data.listings.length === 1 &&
                            window.location.pathname.indexOf(
                                'listing-for-cms'
                            ) < 0 &&
                            rootState.renderStatus !== 1
                        ) {
                            dispatch(NAVIGATOR_DETAIL, data.listings);
                            return;
                        }
                        commit(RESULT_UPDATE_MUTATION, data);
                        state.loading = false;
                        // setTimeout(() => (state.loading = false), 500);
                        if (
                            quickSearchCount &&
                            data.counts != quickSearchCount
                        ) {
                            updateQuickSearchCount(quickSearchKey, data.counts);
                        }
                        if (window.siteAppVm) {
                            window.siteAppVm.$EventBus.$emit('siteTrack', {
                                trackType: 'search-result',
                                data: data.listings,
                                params: params
                            });
                        }
                    })
                );
            }
            commit(QUICK_SEARCH_STATE_MUTATION, 0);
            await Promise.all(ps);
            if (payload.callback && util.isFunction(payload.callback)) {
                payload.callback();
            }
            if (window.siteAppVm) {
                window.siteAppVm.$EventBus.$emit('siteTrack', {
                    trackType: 'search'
                });
            }

            function setDynamicRegisterParams(params) {
                // 不记录地图搜索 只记录listing-search
                if (params?.mapSearch) return;
                // 记录每次搜索的参数，dynamicRegister的时候需要
                localStorage &&
                    localStorage.setItem(
                        'dynamicRegisterParams',
                        JSON.stringify(params) || '{}'
                    );
            }
        },
        [NAVIGATOR_DETAIL]({ state, commit }, payload) {
            if (state.goDetail) {
                commit(SET_GO_DETAIL, false);
                if (
                    Array.isArray(payload) &&
                    payload.length === 1 &&
                    window.location.pathname.indexOf('listing-for-cms') < 0
                ) {
                    const data = payload[0];
                    window.location.href = data.detailLink;
                }
            }
        },
        [UPDATE_URL]({ state, getters }) {
            if (this.forCMS) return;
            console.log('update--UPDATE_URL');
            if (Data.wordPressSSR) return;
            const params = Object.assign(
                state.otherUrlQuery,
                getters.searchParamsWithMap,
                {
                    page: state.page
                }
            );
            if (this.isSearchCenter) {
                delete params.mapPath;
            }
            if (state.mapCondition.zoom) {
                params.zoom = state.mapCondition.zoom;
            }
            if (state.quickSearchState === 0) {
                if (params.quickSearchCount) {
                    delete params.quickSearchCount;
                }
                if (params.quickSearchKey) {
                    delete params.quickSearchKey;
                }
            }
            getters.insightMode && (params.mode = getters.insightMode);
            let url = util.setQueryField(params, window.location.pathname);
            window.history.replaceState({}, null, url);
        }
    };
};

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
